import { Controller } from "@hotwired/stimulus";

let Glide;

export default class extends Controller {
  connect() {
    import("@glidejs/glide").then((module) => {
      Glide = module.default;
      this.init();
    });
  }

  init() {
    this.slider = new Glide(this.element.querySelector(".glide"), {
      type: "carousel",
      perView: 2,
      rewind: false,
      bound: true,
      gap: 30,
      breakpoints: {
        767: {
          perView: 1,
          gap: 16,
          peek: {
            before: 48,
            after: 48,
          },
        },
        // 1000: {
        //   perView: 1,
        //   peek: 40,
        // },
      },
    });

    this.slider.on("run", () => {
      document.body.classList.add("swiping");
    });

    this.slider.on("run.after", () => {
      document.body.classList.remove("swiping");
    });

    this.slider.mount();
  }

  // maybeClick(evt) {
  //   if (this.swiping) {
  //     evt.preventDefault();
  //     evt.stopPropagation();
  //     return false;
  //   }

  //   return true;
  // }

  next() {
    this.slider.go(">");
  }

  prev() {
    this.slider.go("<");
  }

  disconnect() {
    this.slider.destroy();
  }
}
